import React from "react";
import { ColorlibConnector, ColorlibStepIconRoot, MainContainer } from './styles'
import { Step, StepLabel, Stepper } from '@mui/material'
import CustomIcon from "../../../general/CustomIcon";
import PropTypes from "prop-types";

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <CustomIcon name="cloud_download" variant="white" />,
    2: <CustomIcon name="cloud_upload" variant="white" />,
    3: <CustomIcon name="preview" variant="white" />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const steps = ["Descargar plantilla", "Subir archivo", "Previsualizar datos"];

const Steps = ({ activeStep }) => {
  return (
    <MainContainer>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </MainContainer>
  );
};

Steps.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

export default Steps;